module.exports = __webpack_public_path__ + "assets/a201b1706fb5593ec5d19ac4fa0e63c2.mp3";